import { makeVar, useReactiveVar } from "@apollo/client";

import { Customer } from "../../API";

export const selectedCustomerDataVariable = makeVar<Customer | null>(null);

export const useSelectedCustomerData = () =>
  useReactiveVar(selectedCustomerDataVariable);
